import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_LOCAL_STORAGE_SECRET_KEY || '';

/**
 * Creates a consistent hash for keys (deterministic)
 */
const hashKey = (key) => {
  try {
    return CryptoJS.SHA256(key + SECRET_KEY).toString();
  } catch (error) {
    throw error;
  }
};

/**
 * Encrypts data using AES encryption (for values)
 */
const encrypt = (data) => {
  try {
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  } catch (error) {
    throw error;
  }
};

/**
 * Decrypts data using AES decryption (for values)
 */
const decrypt = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    throw error;
  }
};

/**
 * Sets an encrypted item in localStorage with hashed key
 */
export const setLocalStorage = (key, value) => {
  try {
    const hashedKey = hashKey(key);
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encryptedValue = encrypt(stringValue);
    localStorage.setItem(hashedKey, encryptedValue);
  } catch (error) {
    throw error;
  }
};

/**
 * Gets and decrypts an item from localStorage using hashed key
 */
export const getLocalStorage = (key) => {
  try {
    const hashedKey = hashKey(key);
    const encryptedValue = localStorage.getItem(hashedKey);
    if (!encryptedValue) return null;

    const decryptedValue = decrypt(encryptedValue);
    if (!decryptedValue) return null;

    try {
      return JSON.parse(decryptedValue);
    } catch {
      return decryptedValue;
    }
  } catch (error) {
    return null;
  }
};

/**
 * Removes an item from localStorage using hashed key
 */
export const removeLocalStorage = (key) => {
  try {
    const hashedKey = hashKey(key);
    localStorage.removeItem(hashedKey);
  } catch (error) {
    throw error;
  }
};

/**
 * Clears all items from localStorage
 */
export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    throw error;
  }
};

/**
 * Checks if a key exists in localStorage using hashed key
 */
export const hasLocalStorage = (key) => {
  try {
    const hashedKey = hashKey(key);
    return localStorage.getItem(hashedKey) !== null;
  } catch (error) {
    return false;
  }
};

export const keys = {
  HAS_DEFAULT_ADMIN_ROLE: "hasDefaultAdminRole",
};

export default {
  set: setLocalStorage,
  get: getLocalStorage,
  remove: removeLocalStorage,
  clear: clearLocalStorage,
  has: hasLocalStorage,
  keys: keys
};